import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";

const ContactAPI2 = () => {
  // LEFT SIDE (CONTACT DETAILS)
  const [details, setDetails] = useState([]);
  const [errors, setErrors] = useState({});

  // RIGHT SIDE (CONTACT FORM USER INPUT)
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    mobile: "",
    message: "",
  });

  // Validate form 
  const validateForm = () => {
    let newErrors = {};

    // Full Name - only letters and spaces
    if (!form.full_name.trim()) {
      newErrors.full_name = "Full name is required";
    } else if (form.full_name.length < 3) {
      newErrors.full_name = "Name must be at least 3 characters";
    } else if (!/^[a-zA-Z\s]+$/.test(form.full_name)) {
      newErrors.full_name = "Name can only contain letters and spaces";
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = "Invalid email format";
    }

    // Mobile - only 10 digits
    if (!form.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(form.mobile)) {
      newErrors.mobile = "Mobile must be exactly 10 digits";
    }

   // Message - only check if not empty
  if (!form.message.trim()) {
    newErrors.message = "Message is required";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};
  // Fetch LEFT SIDE contact details
  const fetchContactDetails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/get_all_contact_details`);
      setDetails(response.data.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load contact details");
    }
  };

  useEffect(() => {
    fetchContactDetails();
  }, []);

  // Handle form input changes with real-time validation
  const handleInput = (e) => {
    const { name, value } = e.target;
    
    // Real-time input restrictions
    if (name === "full_name") {
      // Only allow letters and spaces
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
      setForm({ ...form, [name]: filteredValue });
    } else if (name === "mobile") {
      // Only allow numbers and max 10 digits
      const filteredValue = value.replace(/[^0-9]/g, "").slice(0, 10);
      setForm({ ...form, [name]: filteredValue });
    } else {
      setForm({ ...form, [name]: value });
    }

    // Clear error for this field when user types
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  // Submit contact form (RIGHT SIDE)
  const submitForm = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      toast.error("Please fix the errors in the form");
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/insert_contact_list_data`,
        form,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        toast.success("Message sent successfully!");
        setForm({
          full_name: "",
          email: "",
          mobile: "",
          message: "",
        });
        setErrors({});
      } else {
        toast.error("Failed to send message");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error sending message");
    }
  };

  return (
    <div className="container-fluid py-5 px-3 px-md-5">
      <div className="text-center mb-5">
        <h6 className="fw-bold text-uppercase">Get in Touch</h6>
        <h1 className="fw-bold display-6">Contact Us</h1>
      </div>

      <div className="row g-4 justify-content-center">
        {/* LEFT SIDE DYNAMIC LIST */}
        <div className="col-12 col-lg-6 col-md-6">
          {details.length > 0 && (
            <div>
              {/* ADDRESS */}
              <div className="d-flex align-items-start shadow-sm rounded px-4 bg-white mb-4 border vertpadding border-2">
                <i className="bi bi-geo-alt fs-1 me-3 px-3 bg-icon"></i>
                <div>
                  <h5 className="fw-bold mb-0">Our Location</h5>
                  <p className="mb-0">{details[0].address}</p>
                </div>
              </div>

              {/* MOBILE */}
              <div className="d-flex align-items-start shadow-sm rounded px-4 vertpadding bg-white mb-4 border border-2">
                <i className="bi bi-telephone-inbound fs-1 me-3 px-3 bg-icon"></i>
                <div className="">
                  <h5 className="fw-bold mb-1">Call Us</h5>
                  <p className="mb-0">{details[0].mobile}</p>
                </div>
              </div>

              {/* EMAIL */}
              <div className="d-flex align-items-start shadow-sm rounded px-4 vertpadding bg-white border border-2">
                <i className="bi bi-envelope fs-1 me-3 px-3 bg-icon"></i>
                <div>
                  <h5 className="fw-bold mb-1">Email</h5>
                  <p className="mb-0">{details[0].email}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="col-12 col-lg-6 col-md-6">
          <div className="bg-white rounded shadow-sm p-md-5 px-3 border border-2">
            <h4 className="fw-bold mb-3 text-center mt-sm-1">Send Us a Message</h4>

            <form onSubmit={submitForm}>
              <div className="mb-3">
                <label className="form-label fw-bold">Full Name</label>
                <input
                  type="text"
                  name="full_name"
                  className={`form-control p-2 ${errors.full_name ? 'is-invalid' : ''}`}
                  value={form.full_name}
                  onChange={handleInput}
                  placeholder="Enter your name"
                />
                {errors.full_name && (
                  <small className="text-danger d-block mt-1">{errors.full_name}</small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Email</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control p-2 ${errors.email ? 'is-invalid' : ''}`}
                  value={form.email}
                  onChange={handleInput}
                  placeholder="Enter your email"
                />
                {errors.email && (
                  <small className="text-danger d-block mt-1">{errors.email}</small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Mobile Number</label>
                <input
                  type="tel"
                  name="mobile"
                  className={`form-control p-2 ${errors.mobile ? 'is-invalid' : ''}`}
                  value={form.mobile}
                  onChange={handleInput}
                  placeholder="Enter your 10-digit mobile number"
                  maxLength="10"
                />
                {errors.mobile && (
                  <small className="text-danger d-block mt-1">{errors.mobile}</small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Message</label>
                <textarea
                  name="message"
                  className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                  rows="4"
                  value={form.message}
                  onChange={handleInput}
                  placeholder="Write your message..."
                ></textarea>
                {errors.message && (
                  <small className="text-danger d-block mt-1">{errors.message}</small>
                )}
              </div>

              <button
                type="submit"
                className="border-0 rounded-1 text-light w-100 mt-2 py-2 mb-sm-2 fw-bold bg-col"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactAPI2;